"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconLibrary = require("../IconLibrary");

var _index = _interopRequireDefault(require("./index.styled"));

var _react2 = _interopRequireDefault(require("@tippyjs/react"));

require("tippy.js/dist/tippy.css");

require("tippy.js/themes/light.css");

var _excluded = ["icon", "title", "paragraph"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var generateCopy = function generateCopy(title, paragraph) {
  return /*#__PURE__*/_react.default.createElement(_index.default.TooltipBox, null, title && /*#__PURE__*/_react.default.createElement("div", {
    className: "title"
  }, title), /*#__PURE__*/_react.default.createElement("div", {
    className: "paragraph"
  }, paragraph));
};

var Tooltip = function Tooltip(_ref) {
  var icon = _ref.icon,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? '' : _ref$title,
      _ref$paragraph = _ref.paragraph,
      paragraph = _ref$paragraph === void 0 ? '' : _ref$paragraph,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_index.default.Tooltip, null, /*#__PURE__*/_react.default.createElement(_react2.default, _extends({
    content: generateCopy(title, paragraph),
    arrow: window.innerWidth < 720 ? false : true,
    trigger: "mouseenter click",
    theme: "light",
    role: "tooltip",
    maxWidth: "calc(100vw - 80px)",
    popperOptions: {
      modifiers: [{
        name: 'center',
        enabled: true,
        fn: function fn(_ref2) {
          var state = _ref2.state;
          state.styles.popper.width = 'calc(100vw - 40px)';
        },
        phase: 'beforeWrite',
        requires: ['computeStyles', 'applyStyles'],
        effect: function effect(_ref3) {
          var state = _ref3.state;
          state.elements.popper.style.width = "".concat(state.elements.reference.clientWidth, "px");
          state.elements.popper.style.maxWidth = '380px';
        }
      }]
    }
  }, props), /*#__PURE__*/_react.default.createElement("button", {
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, icon || /*#__PURE__*/_react.default.createElement(_IconLibrary.QuestionMark, null))));
};

exports.Tooltip = Tooltip;
Tooltip.propTypes = {
  /**
   * Default width is 100%, override with this prop (eg: '250px')
   **/
  width: _propTypes.default.string
};